/** Salt applicativo per l’hash admin (stesso usato in hashPassword). */
export const ADMIN_HASH_SALT = 'sede-zona-galatea|v1|';

/** SHA-256 hex della password, con salt applicativo. */
export async function hashPassword(password: string): Promise<string> {
  const data = new TextEncoder().encode(`${ADMIN_HASH_SALT}${password}`);
  const digest = await crypto.subtle.digest('SHA-256', data);
  return Array.from(new Uint8Array(digest))
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('');
}
